module.exports = __webpack_public_path__ + "static/media/EquipmentService.cc118b75.png";